import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';
import { Setting } from '../../../../common/types/settings';

const childForm = (advisors: Setting[]): Form<Client> => {
  const advisorOptions = advisors.map((advisor) => advisor.value);

  return {
    key: 'childData',
    title: 'Kinder',
    fields: [
      {
        key: 'childrenResponsible',
        label: 'Zuständig',
        fieldTypes: 'autocomplete',
        options: advisorOptions,
        breakRowAfterField: true,
      },
      {
        key: 'numberOfChildrenAtFH',
        label: 'Kinder im FH aufgenommen',
        fieldTypes: 'number',
      },
      {
        key: 'numberOfChildrenNotAtFH',
        label: 'Kinder nicht im FH (unter 18 Jahren)',
        fieldTypes: 'number',
      },
      {
        key: 'childrenNotice',
        label: 'Allgemeine Notiz',
        fieldTypes: 'textArea',
        xsWidth: 12,
      },
      {
        key: 'isChildPlacedInFosterCare',
        label: 'In Obhutname',
        fieldTypes: 'checkbox',
      },
      {
        key: 'childPlacedInFosterCareDate',
        label: 'Datum der in Obhutname',
        fieldTypes: 'date',
      },
      {
        key: 'isChildUnaccompanied',
        label: 'Umgang unbegleitet',
        fieldTypes: 'checkbox',
      },
      {
        key: 'childCustody',
        label: 'Sorgerecht',
        fieldTypes: 'text',
      },
    ],
  };
};

export default childForm;
